import { enMessages } from './languages/EN.lang';
import { plMessages } from './languages/PL.lang';

export const interriskTranslations = {
  pl: plMessages,
  en: enMessages,
};
